import { FC } from 'react';
import classes from '../../asset/css/subscription-detail/list-select-tab.module.css';
import { RecommendProductInfoType } from '../../types/recommend-product-info-type';
import { RecommendProductInfo } from './RecommendProductInfo';

export const ListSelectTab: FC<{
  recommendProductInfos: RecommendProductInfoType[];
  loading: boolean;
  changeActiveFunc: (active: boolean, variantId: string, planId?: string, lineId?: string) => void;
}> = ({ recommendProductInfos, loading, changeActiveFunc }) => {
  const recommendProductInfosHtml = recommendProductInfos.map((productInfo, idx) => {
    return (
      <RecommendProductInfo
        active={false}
        productInfo={productInfo}
        loading={loading}
        changeActiveFunc={changeActiveFunc}
        key={idx}
      />
    );
  });

  return (
    <>
      <div className={classes.mypage_subsc_list_section}>
        <h4 className={classes.mypage_subsc_list_title}>毎月のプランに追加する</h4>
        <ul className={`${classes.mypage_subsc_list} ${classes.mypage_recommend_list}`}>{recommendProductInfosHtml}</ul>
      </div>
    </>
  );
};
